/**
 * En principio lo que hacemos es cargar librerías generales que se usan en todas
 * partes como es Turbo, Stimulus etc.
 */

import '../apps/cifra/turbo_loader';
import { registrarComponentes } from '../components/cifra';
import { registrarControladores } from '../apps/cifra';

// WebComponent cifra-vue
import '../components/CifraVue';

registrarComponentes();
registrarControladores();
